import { nakiRadioSystemTypes } from "common/constants";
import nakiHardwareFamily from "common/constants/nakiHardwareFamily";
import React from "react";

function StationUnavailableInAppTemplate({ selectedDevice }) {
    const hardwareFamily = selectedDevice?.nakiHardwareFamily;
    const systemTypeAbrv = selectedDevice?.systemType?.abrv;

    let message = "This station is not available ";
    if (systemTypeAbrv === nakiRadioSystemTypes.mobile) {
        message += "in the mobile application";
    } else if (systemTypeAbrv === nakiRadioSystemTypes.mobile_embedded) {
        message += "on the Bolt device";
    } else if (systemTypeAbrv === nakiRadioSystemTypes.venice && hardwareFamily === nakiHardwareFamily.pulse) {
        message += "on the Pulse device";
    }

    return <p className="u-type--sml u-type--color--warning--light">{message}</p>;
}

export default StationUnavailableInAppTemplate;
